import { Component } from 'opus-angular-seed-core';

@Component({
    bindings: {
        question: '=',
        form: '=',
        counter: '=',
        answeredQuestions: '=',
        disabled: '<'
    },
    template: `
        <div class="alert alert-danger" ng-if="vm.form.answers[vm.question.id].errors.answerId">{{ vm.form.answers[vm.question.id].errors.answerId }}</div>
        <h3 ng-bind-html="vm.questionName | isRequired: vm.question.formQuestions[0].isRequired"></h3>
        <ul class="items10">
            <li ng-if="vm.question.imageFilename" ng-style="{ 'background-image': 'url('+vm.QuestionService.getImageUrl(vm.question)+')' }">
                <a class="overlay" ng-click="vm.openImageModal(vm.question)">{{ 'general.Zoom in' | translate }}</a>
            </li>
        </ul>
        <ul class="checkboxes inxcols">
            <li ng-repeat="answer in vm.question.questionAnswers">
                <label><input
                    type="radio"
                    ng-model="vm.answer.answerId"
                    ng-change="vm.onChange('{{vm.answer.answerId}}')"
                    ng-value="answer.id" name="question-{{ vm.question.id }}"
                    ng-disabled="vm.disabled"
                ><span>{{ answer.text }}</span></label>
            </li>
        </ul>
    `
})
export default class {
    constructor (lodash, QuestionService) {
        this.submittedAnswerId = lodash.get(this.question, 'submittedAnswer.id', null);
        this.submittedAnswerAnswerId = lodash.get(this.question, 'submittedAnswer.answerId', null);
        this.answer = {
            id: this.submittedAnswerId,
            questionId: this.question.id,
            language: this.form.language,
            answerId: this.submittedAnswerAnswerId
        };
        this.form.answers[this.question.id] = this.answer;
        this.QuestionService = QuestionService;
    }

    $onInit () {
        this.questionName = `${this.counter}. ${this.question.activeI18n.name}`;
        if (this.submittedAnswerId && this.submittedAnswerAnswerId) {
            this.answeredQuestions = this.answeredQuestions + 1;
        }
    }

    onChange (oldAnswerId) {
        if (oldAnswerId) {
            this.answeredQuestions = this.answeredQuestions - 1;
        }
        this.form.answers[this.question.id] = this.answer;
        this.answeredQuestions = this.answeredQuestions + 1;
    }
}



// WEBPACK FOOTER //
// ./src/app/components/survey/public/survey/question/radio/index.js